exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".loading-text{padding-left:.5em;display:inline-block;font-weight:500}.spinningCircle{display:inline-block;height:18px;width:18px;margin-top:5px;border-radius:50%;border:4px solid #397ee0;-webkit-animation:single2 2s infinite linear;animation:single2 2s infinite linear}@-webkit-keyframes single2{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg);border-top-color:hsla(0,0%,100%,0);border-right-color:hsla(0,0%,100%,0)}50%{border-top-color:hsla(0,0%,100%,0);border-right-color:hsla(0,0%,100%,0)}to{-webkit-transform:rotate(2turn);transform:rotate(2turn);border-top-color:hsla(0,0%,100%,0);border-right-color:hsla(0,0%,100%,0)}}@keyframes single2{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg);border-top-color:hsla(0,0%,100%,0);border-right-color:hsla(0,0%,100%,0)}50%{border-top-color:hsla(0,0%,100%,0);border-right-color:hsla(0,0%,100%,0)}to{-webkit-transform:rotate(2turn);transform:rotate(2turn);border-top-color:hsla(0,0%,100%,0);border-right-color:hsla(0,0%,100%,0)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/common/LoaderWithText/index.scss
// module id = 1014
// module chunks = 0